/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ContractDocumentsControllerFindOneQueryResponse, ContractDocumentsControllerFindOnePathParams, ContractDocumentsControllerFindOneQueryParams, ContractDocumentsControllerFindOne400, ContractDocumentsControllerFindOne401, ContractDocumentsControllerFindOne403, ContractDocumentsControllerFindOne404 } from "../../models/contractDocumentsController/ContractDocumentsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { contractDocumentsControllerFindOne } from "../../clients/contract-documentsService/contractDocumentsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const contractDocumentsControllerFindOneQueryKey = (id: ContractDocumentsControllerFindOnePathParams["id"], params: ContractDocumentsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/contract-documents/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ContractDocumentsControllerFindOneQueryKey = ReturnType<typeof contractDocumentsControllerFindOneQueryKey>;
export function contractDocumentsControllerFindOneQueryOptions(id: ContractDocumentsControllerFindOnePathParams["id"], params?: ContractDocumentsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = contractDocumentsControllerFindOneQueryKey(id, params);
  return queryOptions<ContractDocumentsControllerFindOneQueryResponse, ResponseErrorConfig<ContractDocumentsControllerFindOne400 | ContractDocumentsControllerFindOne401 | ContractDocumentsControllerFindOne403 | ContractDocumentsControllerFindOne404>, ContractDocumentsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return contractDocumentsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a contract document
 * {@link /api/v1/contract-documents/:id}
 */
export function useContractDocumentsControllerFindOne<TData = ContractDocumentsControllerFindOneQueryResponse, TQueryData = ContractDocumentsControllerFindOneQueryResponse, TQueryKey extends QueryKey = ContractDocumentsControllerFindOneQueryKey>(id: ContractDocumentsControllerFindOnePathParams["id"], params?: ContractDocumentsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ContractDocumentsControllerFindOneQueryResponse, ResponseErrorConfig<ContractDocumentsControllerFindOne400 | ContractDocumentsControllerFindOne401 | ContractDocumentsControllerFindOne403 | ContractDocumentsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? contractDocumentsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...contractDocumentsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ContractDocumentsControllerFindOne400 | ContractDocumentsControllerFindOne401 | ContractDocumentsControllerFindOne403 | ContractDocumentsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}